import { api } from './client';

export interface KeywordGroup {
  group_id: string;
  project_id: string;
  name: string;
  description: string | null;
  keyword_count: number;
  created_at: string;
  updated_at: string;
}

export interface KeywordItem {
  item_id: string;
  group_id: string;
  keyword: string;
  tags: string[] | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export interface KeywordGroupDetail extends KeywordGroup {
  project_name?: string;
  items: KeywordItem[];
  available_tags: string[];
  sibling_groups?: KeywordGroup[];
}

export type BatchAction = 'add_tag' | 'remove_tag' | 'delete' | 'move';

export const keywordGroupsApi = {
  // Groups
  list: (projectId: string) =>
    api.get<KeywordGroup[]>(`/keyword-groups?project_id=${projectId}`),

  get: (groupId: string) =>
    api.get<KeywordGroupDetail>(`/keyword-groups/${groupId}`),

  create: (data: { project_id: string; name: string; description?: string }) =>
    api.post<{ group_id: string }>('/keyword-groups', data),

  update: (groupId: string, data: { name?: string; description?: string }) =>
    api.patch(`/keyword-groups/${groupId}`, data),

  delete: (groupId: string) =>
    api.delete(`/keyword-groups/${groupId}`),

  // Items
  addItems: (groupId: string, data: { keywords?: string[]; keyword?: string; tags?: string[]; notes?: string }) =>
    api.post<{ created?: number; item_id?: string }>(`/keyword-groups/${groupId}/items`, data),

  updateItem: (groupId: string, itemId: string, data: { keyword?: string; tags?: string[]; notes?: string }) =>
    api.patch(`/keyword-groups/${groupId}/items/${itemId}`, data),

  deleteItem: (groupId: string, itemId: string) =>
    api.delete(`/keyword-groups/${groupId}/items/${itemId}`),

  // Batch
  batch: (groupId: string, data: { action: BatchAction; item_ids: string[]; tag?: string; target_group_id?: string }) =>
    api.post<{ affected: number }>(`/keyword-groups/${groupId}/batch`, data),

  // Tags
  allTags: (projectId: string) =>
    api.get<string[]>(`/keyword-groups/tags/all?project_id=${projectId}`),
};
